import { ShieldAlert } from "lucide-react";

/**
 * Aviso legal obrigatório — aparece em todas as páginas clínicas e no portal.
 * Texto exato aprovado pelo posicionamento legal do produto.
 */
export default function Disclaimer({ compact = false, className = "" }) {
  const content = "Este sistema oferece apoio à avaliação funcional osteopática e não substitui a avaliação clínica profissional nem o diagnóstico médico.";
  if (compact) {
    return (
      <div
        data-testid="disclaimer-compact"
        className={`text-[11px] text-slate-500 leading-relaxed ${className}`}
      >
        {content}
      </div>
    );
  }
  return (
    <div
      data-testid="disclaimer-banner"
      className={`rounded-xl border border-slate-800/80 bg-slate-900/40 p-4 flex items-start gap-3 ${className}`}
    >
      <ShieldAlert className="w-4 h-4 text-amber-300 mt-0.5 shrink-0" strokeWidth={1.5} />
      <div className="text-xs text-slate-400 leading-relaxed">
        <span className="text-slate-300 font-medium">Aviso legal · </span>
        {content}
      </div>
    </div>
  );
}
